import { useNavigate } from "react-router-dom";
import { APP_NAME } from "@shared/util/brand";

export default function StripeCancelPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="relative bg-white dark:bg-gray-800 p-10 rounded-2xl text-center max-w-md w-full shadow-xl">
        <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-red-200 flex items-center justify-center text-3xl">
          ❌
        </div>
        <h3 className="text-2xl font-semibold mb-3 dark:text-gray-100">
          Payment Cancelled
        </h3>
        <p className="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed">
          Your payment was cancelled. If this was a mistake, you can try again
          or contact support.
        </p>
        <button
          onClick={() => navigate("/asset/webinars")}
          className="w-full px-6 py-4 bg-gray-100 hover:bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-gray-200 font-medium rounded-lg"
        >
          Go to the {APP_NAME} home page!
        </button>
      </div>
    </div>
  );
}
